<template>
  <section class="hero-bg h-auto bg-[#00284F]">
    <div class="max-w-[1200px] mx-auto px-4 lg:px-8">
      <div class="flex flex-col items-right pt-28 pb-20 md:pt-36 lg:pt-40 font-oxanium">
        <!-- Header -->
        <div class="text-center mb-8">
          <h1 class="text-5xl sm:text-6xl font-extrabold font-golos-text">MILESTONES</h1>
          <p class="text-lg sm:text-2xl font-montserrat">CLAIM YOUR MILESTONE REWARDS</p>
        </div>

        <!-- Profile Card -->
        <MilestoneProfileCard/>

        <!-- Milestone Section -->
        <div
          class="text-white font-bold inline-flex items-center px-4 mb-8 font-montserrat"
          style="
            width: auto;
            height: 51px;
            gap: 16px;
            border-radius: 10px;
            background: linear-gradient(90.59deg, #1d1d1d 0%, #313b44 100%);
          "
        >
          <span>🎯</span>
          <span>Wager Milestone</span>
        </div>

        <!-- Milestone Rewards Grid with Timeline -->
        <div class="bg-transparent rounded-xl mb-6">
          <div
            v-if="loadingMilestones == true"
            class="flex flex-col justify-center items-center mt-8 md:mt-14"
          >
            <div
              class="w-24 h-24 rounded-full animate-spin border-y-8 border-solid border-white border-t-transparent"
            ></div>
          </div>

          <div v-else-if="loadingMilestones == false && userToken" class="grid grid-cols-1 gap-4">
            <!-- Timeline Container -->
            <div
              class="relative"
              v-motion-pop-visible
              v-for="(m, index) in milestones.milestones"
              :key="m.id || index"
            >
              <div
                v-if="index !== milestones.milestones.length - 1"
                class="absolute left-[12px] top-0 bottom-0 w-0.5 bg-[#3D85C6] z-0"
                style="height: calc(100% + 15px); margin-top: 30px"
              ></div>
              <!-- First Reward -->
              <div class="flex items-center mb-4">
                <!-- Timeline Node -->
                <div class="relative z-10 mr-4">
                  <div
                    class="w-6 h-6 rounded-full bg-[#3D85C6] border-2 border-white"
                  ></div>
                </div>
                <!-- Reward Card -->
                <div
                  class="flex-1 flex flex-col sm:flex-row items-center justify-between bg-[#1D1D1D] rounded-2xl p-4 gap-4"
                >
                  <!-- Current Wager with icon -->
                  <div class="flex items-center gap-4 w-full sm:w-auto">
                    <img
                      src="../assets/money-bag-dynamic-color.png"
                      class="w-12 h-12"
                      alt="Wager"
                    />
                    <div>
                      <p class="text-sm text-white-400 font-montserrat">Current Wager</p>
                      <p class="font-bold text-lg font-orbitron" style="color: #eeaf0e">
                        ${{ m.requiredWager }}
                      </p>
                    </div>
                  </div>
                  <!-- Reward with icon -->
                  <div class="flex items-center gap-4 w-full sm:w-auto">
                    <img
                      src="../assets/money-dynamic-color.png"
                      class="w-12 h-12"
                      alt="Reward"
                    />
                    <div>
                      <p class="text-sm text-gray-400">Reward</p>
                      <p class="font-bold text-lg font-orbitron" style="color: #eeaf0e">
                        ${{ m.reward }}
                      </p>
                    </div>
                  </div>

                  <!-- Claim Button with icon -->
                  <button
                    v-if="m.userMilestone?.status === 'Completed'"
                    @click="claimReward(m)"
                    class="flex items-center justify-center gap-2 w-full sm:w-auto bg-[#1689DB] hover:bg-[#1a76c4] text-white font-semibold py-3 px-6 rounded-md font-montserrat"
                  >
                    <img
                      src="../assets/tabler-icon-moneybag.png"
                      class="w-5 h-5"
                      alt="Claim"
                    />
                    Claim Reward
                  </button>

                  <!-- Disabled Claim -->
                  <button
                    v-else-if="m.userMilestone?.status === 'Claimed'"
                    class="flex items-center justify-center gap-2 w-full sm:w-auto bg-[#262626] text-white font-semibold py-3 px-6 rounded-md font-montserrat disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#262626]"
                    disabled
                  >
                    <img
                      src="../assets/tabler-icon-moneybag-no-color.png"
                      class="w-5 h-5"
                      alt="Claim"
                    />
                    Reward Claimed
                  </button>

                  <!-- Disabled Claim -->
                  <button
                    v-else
                    class="flex items-center justify-center gap-2 w-full sm:w-auto bg-[#262626] text-white font-semibold py-3 px-6 rounded-md font-montserrat disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#262626]"
                    disabled
                  >
                    <img
                      src="../assets/tabler-icon-moneybag-no-color.png"
                      class="w-5 h-5"
                      alt="Claim"
                    />
                    Claim Reward
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="loadingMilestones == false && userToken === null" class="grid grid-cols-1 gap-4">
            <!-- Timeline Container -->
            <div
              class="relative"
              v-motion-pop-visible
              v-for="(m, index) in milestonesArray"
              :key="m.id || index"
            >
              <div
                v-if="index !== milestonesArray.length - 1"
                class="absolute left-[12px] top-0 bottom-0 w-0.5 bg-[#3D85C6] z-0"
                style="height: calc(100% + 15px); margin-top: 30px"
              ></div>
              <!-- First Reward -->
              <div class="flex items-center mb-4">
                <!-- Timeline Node -->
                <div class="relative z-10 mr-4">
                  <div
                    class="w-6 h-6 rounded-full bg-[#3D85C6] border-2 border-white"
                  ></div>
                </div>
                <!-- Reward Card -->
                <div
                  class="flex-1 flex flex-col sm:flex-row items-center justify-between bg-[#1D1D1D] rounded-2xl p-4 gap-4"
                >
                  <!-- Current Wager with icon -->
                  <div class="flex items-center gap-4 w-full sm:w-auto">
                    <img
                      src="../assets/money-bag-dynamic-color.png"
                      class="w-12 h-12"
                      alt="Wager"
                    />
                    <div>
                      <p class="text-sm text-white-400 font-montserrat">Current Wager</p>
                      <p class="font-bold text-lg font-orbitron" style="color: #eeaf0e">
                        ${{ m.wager }}
                      </p>
                    </div>
                  </div>
                  <!-- Reward with icon -->
                  <div class="flex items-center gap-4 w-full sm:w-auto">
                    <img
                      src="../assets/money-dynamic-color.png"
                      class="w-12 h-12"
                      alt="Reward"
                    />
                    <div>
                      <p class="text-sm text-gray-400">Reward</p>
                      <p class="font-bold text-lg font-orbitron" style="color: #eeaf0e">
                        ${{ m.reward }}
                      </p>
                    </div>
                  </div>
                  <!-- Disabled Claim -->
                  <button
                    class="flex items-center justify-center gap-2 w-full sm:w-auto bg-[#262626] text-white font-semibold py-3 px-6 rounded-md font-montserrat disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#262626]"
                    disabled
                  >
                    <img
                      src="../assets/tabler-icon-moneybag-no-color.png"
                      class="w-5 h-5"
                      alt="Claim"
                    />
                    Not Logged in
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="showConfirmRewardsModal == true"
      class="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-70 transition-opacity"
        aria-hidden="true"
      ></div>
      <div
        class="fixed inset-0 z-10 w-screen overflow-y-auto"
        style="font-family: Oxanium, sans-serif"
      >
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <div
            v-motion-pop-visible
            class="relative overflow-hidden text-center shadow-xl sm:my-8 sm:w-full sm:max-w-3xl"
          >
            <div class="cards-frame px-10 pb-4 pt-5 sm:pt-10 sm:px-8 sm:pb-8">
              <div class="mt-3 text-center sm:mt-0 sm:text-center">
                <h3
                  class="text-xl lg:text-3xl font-semibold leading-6 text-white uppercase"
                  id="modal-title"
                >
                  CONFIRM REWARD CLAIM
                </h3>
                <p class="mb-6 pt-2">
                  Are you sure you want to claim
                  <span class="text-yellow-400 font-orbitron"
                    >${{ selectedReward?.reward }}</span
                  >
                  for reaching
                  <span class="text-yellow-400 font-orbitron"
                    >${{ selectedReward?.requiredWager }}</span
                  >
                  wager milestone?
                </p>
              </div>
              <div
                class="hidden sm:flex mt-8 flex-row justify-center gap-10 mb-2"
                style="font-family: Oxanium, sans-serif"
              >
                <button
                  @click="showConfirmRewardsModal = false"
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md px-16 py-4 text-sm font-semibold hover:text-white hover:bg-[#1689DB] shadow-lg sm:mt-0 sm:w-auto text-white bg-transparent border border-white hover:border-[#1294F0] font-base relative uppercase main-btn"
                >
                  Close
                  <span
                    class="absolute inset-x-0 bottom-0 h-1 bg-white mx-auto w-16"
                  ></span>
                </button>
                <button
                  @click="confirmClaim"
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md px-16 py-4 text-sm font-semibold hover:text-white hover:bg-[#1689DB] shadow-lg sm:mt-0 sm:w-auto text-white bg-[#1294F0] border border-white hover:border-[#1294F0] font-base relative uppercase main-btn"
                >
                  Yes, Claim
                  <span
                    class="absolute inset-x-0 bottom-0 h-1 bg-white mx-auto w-16"
                  ></span>
                </button>
              </div>
              <div
                class="flex sm:hidden mt-4 flex-col justify-center"
                style="font-family: Oxanium, sans-serif"
              >
                <button
                  @click="showConfirmRewardsModal = false"
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md px-14 py-4 text-sm font-semibold hover:text-white hover:bg-[#1689DB] shadow-lg sm:mt-0 sm:w-auto text-white bg-transparent border border-white hover:border-[#1294F0] font-base relative uppercase main-btn"
                >
                  Close
                  <span
                    class="absolute inset-x-0 bottom-0 h-1 bg-white mx-auto w-24"
                  ></span>
                </button>
                <button
                  @click="confirmClaim"
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md px-14 py-4 text-sm font-semibold hover:text-white hover:bg-[#1689DB] shadow-lg sm:mt-0 sm:w-auto text-white bg-[#1294F0] border border-white hover:border-[#1294F0] font-base relative uppercase main-btn"
                >
                  Yes, Claim
                  <span
                    class="absolute inset-x-0 bottom-0 h-1 bg-white mx-auto w-16"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
  v-show="showClaimSuccessModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
  style="font-family: Oxanium, sans-serif"
>
  <div
    v-motion-pop-visible
    class="bg-[#1D1D1D] rounded-xl shadow-lg max-w-xl w-full p-8 text-center text-white"
  >
    <h2 class="text-2xl lg:text-3xl font-bold uppercase mb-4">
      Reward Claimed!
    </h2>
    <p class="mb-6">
      Please proceed to our <span class="text-yellow-400 font-bold">Discord Channel</span>
     to finalize your reward.
    </p>
    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <button
        @click="showClaimSuccessModal = false"
        class="w-full sm:w-auto px-8 py-3 rounded-md text-white bg-transparent border border-white hover:bg-white hover:text-black transition-all"
      >
        Close
      </button>
      <a
        href="https://discord.com/invite/Rh6kTmSJuP"
        target="_blank"
        rel="noopener noreferrer"
        class="w-full sm:w-auto px-8 py-3 rounded-md text-white bg-[#5865F2] hover:bg-[#4752c4] transition-all"
      >
        Go to Discord
      </a>
    </div>
  </div>
</div>
  </section>
</template>

<script>
import axios from "axios";
import store from '@/store'
import { defineComponent } from "vue";
import MilestoneProfileCard from '../components/MilestoneProfileCard.vue'

export default defineComponent({
  components: {
    MilestoneProfileCard
  },
  data() {
    return {
      userToken: null,
      showConfirmRewardsModal: false,
      showClaimSuccessModal: false,
      selectedReward: null,

      loadingMilestones: true,
      displayName: null,
      picUrl: null,
      discordID: null,

      userPoints: 0,
      animatedPoints: 0,
      animatedCurrentWager: 0,

      milestones: [],

      milestonesArray: [
        { reward: "50", wager: "10,000" },
        { reward: "250", wager: "100,000" },
        { reward: "1000", wager: "500,000" },
        { reward: "2,500", wager: "1,500,000" },
        { reward: "5,000", wager: "4,000,000" },
      ],
    };
  },
  methods: {
    init() {
      this.userToken = store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");
      
      if (this.userToken) {
        axios
          .get(process.env.VUE_APP_BASE_API + "/api/user", {
            headers: {
              "x-api-key": process.env.VUE_APP_X_API_KEY,
              Authorization: `Bearer ${this.userToken}`,
            },
          })
          .then((res) => {
            if (res.data) {
              this.displayName = res.data.user.username;
              this.picUrl =
                "https://cdn.discordapp.com/avatars/" +
                res.data.user.discordId +
                "/" +
                res.data.user.profileImage +
                ".png";
              this.discordID = res.data.user.discordId;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 401) {
                localStorage.removeItem("vuex");
                localStorage.removeItem("ballyboy-access-token");
                window.location.reload();
              } else {
                console.log(`Error: ${error.response.status}`);
              }
            } else if (error.request) {
              console.log("No response received", error.request);
            } else {
              console.log("Error", error.message);
            }
          });
      }
    },

    initUserPoints() {
      this.userToken = store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");
      if (this.userToken == null) {
        this.loadingMilestones = false;
        return;
      }
      axios
        .get(process.env.VUE_APP_BASE_API + "/api/user/points", {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${this.userToken}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.userPoints = res.data.points;
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("vuex");
              localStorage.removeItem("ballyboy-access-token");
              window.location.reload();
            } else {
              console.log(`Error: ${error.response.status}`);
            }
          } else if (error.request) {
            console.log("No response received", error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    initMilestone() {
      this.userToken = store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");
      if (this.userToken == null) {
        this.loadingMilestones = false;
        return;
      }
      axios
        .get(process.env.VUE_APP_BASE_API + "/api/user/milestones", {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${this.userToken}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.milestones = res.data.milestones[0];
            this.totalWagers = res.data.totalWagers[0] ?? 0;
            this.loadingMilestones = false;

            this.animateValues();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("vuex");
              localStorage.removeItem("ballyboy-access-token");
              window.location.reload();
            } else {
              console.log(`Error: ${error.response.status}`);
            }
          } else if (error.request) {
            console.log("No response received", error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    cancelClaim() {
      this.selectedReward = null;
      this.showConfirmRewardsModal = false;
    },
    claimReward(milestone) {
      this.selectedReward = milestone;
      this.showConfirmRewardsModal = true;
    },
    confirmClaim() {
      this.loadingMilestones = true;
      const token = localStorage.getItem("ballyboy-access-token");

      axios
        .post(
          process.env.VUE_APP_BASE_API + "/api/user/milestones/claim",
          {
            userMilestoneId: this.selectedReward.userMilestone._id,
          },
          {
            headers: {
              "x-api-key": process.env.VUE_APP_X_API_KEY,
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data) {
            this.init();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("vuex");
              localStorage.removeItem("ballyboy-access-token");
              window.location.reload();
            } else {
              this.errorShow = true;
              this.errorMessage = error.response.data.message;
              console.log(`Error: ${error.response.status}`);
              setTimeout(() => {
                this.errorShow = false;
              }, 3000);
            }
          } else if (error.request) {
            console.log("No response received", error.request);
          } else {
            console.log("Error", error.message);
          }
        })
        .finally(() => {
          this.loadingMilestones = false;
          this.init();
          this.initUserPoints();
          this.initMilestone();
        });
      console.log("Reward claimed for:", this.selectedReward);
      // Example success flow
      this.$toast?.success("Reward successfully claimed!");
      this.showConfirmRewardsModal = false;
      this.showClaimSuccessModal = true;
    },
    isMobile() {
      return window.innerWidth < 1024;
    },
  },
  mounted() {
    this.init();
    this.initUserPoints();
    this.initMilestone();
  },
});
</script>

<style scoped>
.hero-bg {
  background-image: url("../assets/hero-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
}
.hero-bg-mobile {
  background-image: url("../assets/hero-bg-mobile.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.cards-frame {
  background-image: url("../assets/cards-frame.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.milestone-card-bg {
  background: rgb(252, 252, 252);
  background: -moz-linear-gradient(
    148deg,
    rgba(252, 252, 252, 0.1) 0%,
    rgba(18, 148, 240, 0.1) 100%
  );
  background: -webkit-linear-gradient(
    148deg,
    rgba(252, 252, 252, 0.1) 0%,
    rgba(18, 148, 240, 0.1) 100%
  );
  background: linear-gradient(
    148deg,
    rgba(252, 252, 252, 0.1) 0%,
    rgba(18, 148, 240, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fcfcfc",endColorstr="#1294f0",GradientType=1);
  padding: 1px;
}
</style>
